import Image from 'next/image';

import { Box, Button, Heading, Modal, Paragraph, Tag, TextButton } from '@zillow/constellation-10';

import { SELL_HOME_ILLUSTRATION_URL } from '../../../constants/DigitalLibraryConstants';

type Props = {
  open: boolean;
  onClose: () => void;
  onBuildManually: () => void;
  onDraftWithAI: () => void;
};

const AIListingCreationIntroductionModal = ({ open, onClose, onBuildManually, onDraftWithAI }: Props) => (
  <Modal
    header={
      <Tag size="sm" tone="purple">
        Beta
      </Tag>
    }
    body={
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '400' }}>
        <Image src={SELL_HOME_ILLUSTRATION_URL} alt="" role="presentation" width={380} height={240} />
        <Heading level={2} textStyle="heading-sm" css={{ textAlign: 'center' }}>
          Build your listing faster than ever with AI assistance
        </Heading>
        <Paragraph>
          Now your photos and notes can be used to draft a property description and add amenity details, while you take
          care of specifics like rent price and screening criteria. Then, simply review, revise, and publish!
        </Paragraph>
      </Box>
    }
    footer={
      <Box
        aria-label="Build listing options"
        css={{
          display: 'flex',
          flexDirection: { base: 'column', md: 'row' },
          alignItems: { base: 'stretch', md: 'center' },
          justifyContent: { md: 'flex-end' },
          gap: '300',
          width: '100%',
        }}
      >
        <TextButton tone="brand" onClick={onBuildManually} css={{ width: { base: '100%', md: 'auto' } }}>
          Build listing manually instead
        </TextButton>
        <Button tone="brand" emphasis="filled" onClick={onDraftWithAI} css={{ width: { base: '100%', md: 'auto' } }}>
          Draft with AI
        </Button>
      </Box>
    }
    open={open}
    onOpenChange={(isOpen) => !isOpen && onClose()}
    size={{ base: 'fullScreen', md: 'md' }}
    dividers={false}
  />
);

export default AIListingCreationIntroductionModal;
